import type { FC } from 'react'

import { useUnit } from 'effector-react'

import { ErrorBoundary } from '@/components/ui/ErrorBoundary/ErrorBoundary.tsx'
import { $openedDialogs } from '@/models/dialogs.ts'

import { dialogsMap } from './declarations.tsx'

export interface Props {}

export const DialogsRoot: FC<Props> = () => {
  const dialogs = useUnit($openedDialogs)

  return dialogs.map(({ id, type, ...rest }) => {
    const DialogComponent = dialogsMap[type]

    if (!DialogComponent) {
      return null
    }

    return (
      <ErrorBoundary
        key={`${type}-${id}`}
        fallbackTemplate="dialog"
        boundaryName={type}
        resetKeys={[id]}
        onReset={rest.onClose}
      >
        {/* @ts-ignore */}
        <DialogComponent {...rest} />
      </ErrorBoundary>
    )
  })
}

DialogsRoot.displayName = 'DialogsRoot'
